<template>
  <div>
    <p class="text-white/80" v-bind="$attrs"><slot /></p>
  </div>
</template>

<script setup></script>
